import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

interface CookieBannerContainerProps {}

export const CookieBannerContainer = styled("div", {
  shouldForwardProp: prop => prop !== "fixed",
})<CookieBannerContainerProps>(
  ({ theme }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1000;

    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    padding: 14px 16px;
    border-top: 1px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};
    backdrop-filter: blur(24px);

    p,
    & .MuiButton-root {
      ${cssPropertiesToString(theme.typography.paragraph_small_regular)}
    }

    ${theme.breakpoints.up("mobile")} {
      flex-direction: column;
    }

    ${theme.breakpoints.up("tablet")} {
      flex-direction: row;
      gap: 2rem;
    }
  `,
);

export const CookieBannerButtons = styled("div")(
  ({ theme }) => css`
    display: flex;
    align-items: center;

    flex-shrink: 0;

    & .MuiButton-root {
      padding: 11px 8px;
    }

    ${theme.breakpoints.up("mobile")} {
      flex-direction: column;
      gap: 8px;

      width: 100%;
      & .MuiButton-root {
        width: 100%;
      }
    }

    ${theme.breakpoints.up("tablet")} {
      flex-direction: row;
      gap: 16px;

      width: max-content;
      & .MuiButton-root {
        width: max-content;
      }
    }
  `,
);
